import { Link } from 'react-router-dom'

import { Button } from '@/shared/components/ui/button'
import { Card, CardBody, CardHeader, CardTitle } from '@/shared/components/ui/card'

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--app-bg)] px-4">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle>Страница не найдена</CardTitle>
        </CardHeader>
        <CardBody className="space-y-4">
          <p className="text-sm text-[var(--color-text-soft)]">
            Проверьте URL или вернитесь к списку проектов.
          </p>
          <Link to="/projects">
            <Button>Перейти к проектам</Button>
          </Link>
        </CardBody>
      </Card>
    </main>
  )
}
